import {
  Button,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  Image,
  Box,
  VStack,
  FormControl,
  FormLabel,
  useColorModeValue,
  Icon,
  Link,
  HStack,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";

import logo from "../../images/logo_short.svg";

export const Login = () => {
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);
  const navigate = useNavigate();
  const { handleLogin, isLoading, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const onSubmit = async () => {
    const success = await handleLogin({ login: email, password });
    if (success) {
      navigate("/");
    }
  };

  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/");
    }
  }, [navigate]);

  const bgGradient = useColorModeValue("linear(to-br, gray.50, blue.50, purple.50)", "linear(to-br, gray.900, blue.900, purple.900)");

  const cardBg = useColorModeValue("white", "gray.800");
  const cardShadow = useColorModeValue(
    "0 25px 50px -12px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(255, 255, 255, 0.05)",
    "0 25px 50px -12px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.05)",
  );

  return (
    <Flex w="100vw" h="100vh" alignItems="center" justifyContent="center" bgGradient={bgGradient} position="relative">
      <Box
        position="absolute"
        top="0"
        left="0"
        w="100%"
        h="100%"
        bgImage="radial-gradient(circle at 25% 25%, rgba(79, 70, 229, 0.1) 0%, transparent 50%), radial-gradient(circle at 75% 75%, rgba(147, 51, 234, 0.1) 0%, transparent 50%)"
      />

      <Box position="relative" w="100%" maxW="420px" mx="auto" px={6}>
        <Box
          bg={cardBg}
          borderRadius="20px"
          boxShadow={cardShadow}
          backdropFilter="blur(10px)"
          border="1px solid"
          borderColor={useColorModeValue("gray.200", "gray.600")}
        >
          <VStack spacing={8} py={12} px={8}>
            {/* Логотип */}
            <Box textAlign="center">
              <Image src={logo} alt="Logo" h="60px" w="auto" mx="auto" mb={4} />
              <Text fontSize="2xl" fontWeight="700" color={useColorModeValue("gray.900", "white")} letterSpacing="-0.025em">
                Добро пожаловать
              </Text>
              <Text fontSize="md" color={useColorModeValue("gray.600", "gray.400")} mt={2}>
                Войдите в свою учетную запись
              </Text>
            </Box>

            <VStack spacing={6} w="100%">
              <FormControl>
                <FormLabel fontSize="sm" fontWeight="600" color={useColorModeValue("gray.700", "gray.300")} mb={2}>
                  Логин
                </FormLabel>
                <Input
                  placeholder="Введите логин"
                  onChange={(e) => setEmail(e.target.value)}
                  size="lg"
                  bg={useColorModeValue("white", "gray.700")}
                  border="2px solid"
                  borderColor={useColorModeValue("gray.200", "gray.600")}
                  borderRadius="12px"
                  _hover={{
                    borderColor: useColorModeValue("blue.300", "blue.400"),
                  }}
                  _focus={{
                    borderColor: "blue.500",
                    boxShadow: "0 0 0 1px #3182ce",
                  }}
                  _placeholder={{
                    color: useColorModeValue("gray.400", "gray.500"),
                  }}
                />
              </FormControl>

              <FormControl>
                <FormLabel fontSize="sm" fontWeight="600" color={useColorModeValue("gray.700", "gray.300")} mb={2}>
                  Пароль
                </FormLabel>
                <InputGroup size="lg">
                  <Input
                    type={show ? "text" : "password"}
                    placeholder="Введите пароль"
                    onChange={(e) => setPassword(e.target.value)}
                    bg={useColorModeValue("white", "gray.700")}
                    border="2px solid"
                    borderColor={useColorModeValue("gray.200", "gray.600")}
                    borderRadius="12px"
                    _hover={{
                      borderColor: useColorModeValue("blue.300", "blue.400"),
                    }}
                    _focus={{
                      borderColor: "blue.500",
                      boxShadow: "0 0 0 1px #3182ce",
                    }}
                    _placeholder={{
                      color: useColorModeValue("gray.400", "gray.500"),
                    }}
                  />
                  <InputRightElement>
                    <Button variant="ghost" onClick={handleClick} size="sm" _hover={{ bg: "transparent" }}>
                      <Icon as={show ? ViewOffIcon : ViewIcon} color={useColorModeValue("gray.400", "gray.500")} />
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </FormControl>

              <Button
                w="100%"
                size="lg"
                bgGradient="linear(to-r, blue.500, purple.600)"
                color="white"
                borderRadius="12px"
                _hover={{
                  bgGradient: "linear(to-r, blue.600, purple.700)",
                  transform: "translateY(-1px)",
                  boxShadow: "lg",
                }}
                _active={{
                  transform: "translateY(0)",
                }}
                transition="all 0.2s"
                onClick={onSubmit}
                isLoading={isLoading}
                loadingText="Вход..."
                fontWeight="600"
                fontSize="md"
              >
                Войти в систему
              </Button>

              {error && (
                <Box w="100%" p={3} bg="red.50" border="1px solid" borderColor="red.200" borderRadius="8px" textAlign="center">
                  <Text color="red.600" fontSize="sm" fontWeight="500">
                    {error}
                  </Text>
                </Box>
              )}
            </VStack>
          </VStack>
        </Box>
      </Box>

      {/* Футер */}
      <Box position="absolute" bottom="10" left="0" right="0" px={4}>
        <VStack spacing={3} textAlign="center">
          {/* Ссылки */}
          <HStack spacing={6} flexWrap="wrap" justify="center">
            <Link
              href="/instruction.pdf"
              target="_blank"
              rel="noopener noreferrer"
              color="#9eb7dd"
              fontWeight={600}
              _hover={{
                color: useColorModeValue("blue.600", "blue.400"),
              }}
              transition="color 0.2s"
              textDecor="underline"
            >
              Инструкция пользования платформой
            </Link>
            <Text fontSize="sm" color={useColorModeValue("gray.400", "gray.500")}>
              •
            </Text>
            <Link
              href="/pricing"
              target="_blank"
              rel="noopener noreferrer"
              color="#9eb7dd"
              fontWeight={600}
              _hover={{
                color: useColorModeValue("blue.600", "blue.400"),
              }}
              transition="color 0.2s"
              textDecor="underline"
            >
              Тарифы и цены
            </Link>
          </HStack>

          {/* Копирайт */}
          <Text fontSize="xs" color={useColorModeValue("gray.400", "gray.500")}>
            © {new Date().getFullYear()} ООО «ГЛОБУС ИТ». Все права защищены. ИНН 5260365605
          </Text>
        </VStack>
      </Box>
    </Flex>
  );
};
